import { useContext } from 'react';
import { EmailVerificationStatusModalContext } from './EmailVerificationStatusModalProvider';

export const useEmailVerificationStatusModal = () =>
  useContext(EmailVerificationStatusModalContext);
